import { FormControl } from '@procurify/ui'

import {
  TaxSelectCreate,
  type TaxSelectCreateProps,
} from '@webapp/components/TaxSelectCreate/TaxSelectCreate'

interface TaxFormSelectCreateProps {
  id: string
  name: string
  label?: string
  placeholder?: string
  disabled?: boolean
  analyticsId?: string
  onTaxSelected?: TaxSelectCreateProps['onTaxSelected']
  onTaxCreated?: TaxSelectCreateProps['onTaxCreated']
  onModalOpen?: () => void
  onModalClose?: () => void
  onMenuOpen?: () => void
  onMenuClose?: () => void
  menuPortalTarget?: TaxSelectCreateProps['menuPortalTarget']
}

export const TaxFormSelectCreate = ({
  id,
  name,
  label,
  placeholder,
  disabled = false,
  analyticsId,
  onTaxSelected = () => undefined,
  onTaxCreated = () => undefined,
  onModalOpen,
  onModalClose,
  onMenuOpen,
  onMenuClose,
  menuPortalTarget,
}: TaxFormSelectCreateProps) => {
  const inputId = `${id}-input`
  return (
    <FormControl
      disabled={disabled}
      name={name}
      id={id}
      label={label}
      labelFor={inputId}
    >
      {({ value, handleChange, isSubmitting }) => (
        <TaxSelectCreate
          id={id}
          inputId={inputId}
          name={name}
          value={value}
          placeholder={placeholder}
          isDisabled={isSubmitting || disabled}
          analyticsId={analyticsId}
          onTaxSelected={(selectedTax) => {
            handleChange(selectedTax)
            onTaxSelected(selectedTax)
          }}
          onTaxCreated={(createdTax) => {
            handleChange(createdTax)
            onTaxCreated(createdTax)
          }}
          onModalOpen={onModalOpen}
          onModalClose={onModalClose}
          onMenuOpen={onMenuOpen}
          onMenuClose={onMenuClose}
          menuPortalTarget={menuPortalTarget}
        />
      )}
    </FormControl>
  )
}
